import PropTypes from 'prop-types';
import classNames from 'classnames';
import { categoryGroup } from '../proptypes/index';
import { indexRoute } from '../helpers/index';

const CategoryLink = ({ slug, name, active, onClick }) => {
  const invokeCallback = () => {
    onClick(slug);
  };

  const classes = classNames({
    categoryLink: true,
    selected: active,
  });

  return (
    <a href={indexRoute(slug)} onClick={invokeCallback} className={classes}>
      {name}
    </a>
  );
};

CategoryLink.propTypes = {
  onClick: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
};

const CategoriesSidebar = ({ categoryGroups, selectedSlug, onChange }) => {
  const order = ['Featured', 'Categories'];
  const sortedCategoryGroups = categoryGroups.sort((a, b) => {
    return order.indexOf(a.name) - order.indexOf(b.name);
  });

  return (
    <div className="categories">
      <div className="categoryGroupLinks">
        <CategoryLink onClick={onChange} slug="" name="All apps" active={selectedSlug === null} />
        {sortedCategoryGroups.map(g => {
          return (
            <div key={g.name}>
              <h5>{g.name}</h5>
              {g.categories.map(c => (
                <CategoryLink
                  key={c.slug}
                  onClick={onChange}
                  slug={c.slug}
                  name={c.name}
                  active={selectedSlug === c.slug}
                />
              ))}
            </div>
          );
        })}
      </div>

      <select
        className="categorySelectForMobile"
        value={selectedSlug || ''}
        onChange={e => {
          window.location = indexRoute(e.target.value);
        }}
      >
        <option value="">All apps</option>
        {sortedCategoryGroups.map(g => (
          <optgroup label={g.name} key={g.name}>
            {g.categories.map(c => (
              <option key={c.slug} value={c.slug}>
                {c.name}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </div>
  );
};

CategoriesSidebar.propTypes = {
  categoryGroups: PropTypes.arrayOf(categoryGroup).isRequired,
  selectedSlug: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

CategoriesSidebar.defaultProps = {
  selectedSlug: null,
};

export default CategoriesSidebar;
